
import { defineComponent, reactive, ref, computed } from 'vue'
import type { FormInstance, FormRules } from "element-plus";
//interfaces
import { seatInterface } from '@/core/interfaces/seatInterface';
//services
import GlobalService from '@/core/services/GlobalService';
import { errManager, showNotification } from "@/core/config/Tools";
//libraries
import { useI18n } from "vue-i18n/index";
import moment from 'moment';

export default defineComponent({
    name: "dialog-add-edit-seat",
    props: {
        itemSeat: {
            type: null,
            required: false,
            default: () => ({})
        }
    },
    emits: ["onResponseAddEditSeat"],
    setup(props, { emit }) {
        //variables
        const { t } = useI18n();
        const loading = ref(false);
        const titleDialog = ref('');
        const isModalVisible = ref(false);
        const form = reactive<seatInterface>({} as seatInterface);
        const ruleFormRef = ref<FormInstance>();
        const rules = reactive<FormRules>({});

        const getInitialForm = (): seatInterface => ({
            idcompany: 0,
            idseat: 0,
            name: '',
            address: '',
            mstatus: {
                id: 0,
                name: '',
                params: '',
                param2: '',
            }
        });

        const activeText = computed(() => (form.mstatus.id.toString() === '1' ? t('active') : t('inactive')))

        //events
        const openModal = () => {
            isModalVisible.value = true;
        }

        const onOpen = () => {
            titleDialog.value = (props.itemSeat) ? t('edit') : t('register')
            if (props.itemSeat) Object.assign(form, { ...props.itemSeat });
        }

        const onClosed = () => {
            resetForm(ruleFormRef.value);
            Object.keys(form).forEach(key => delete form[key]);
        }

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
        };

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid) => {
                if (valid)
                    return (props.itemSeat) ? update() : save()
            });
        };

        const onRepeat = (data: any) => {
            loading.value = false;
                showNotification(data);
                if(data.status == 'success') {
                    isModalVisible.value = false;
                    emit("onResponseAddEditSeat", data);
                }
        }

        const update = async() => {
            loading.value = true;
            await GlobalService.update('seats', form.idseat, 'update', form)
            .then((res)=>{
                onRepeat(res.data)
            }).catch(({ response }) => {
                loading.value = false;
                errManager(response);
            })
        }

        const save = async() => {
            loading.value = true;
            await GlobalService.post('seats/save', form)
            .then((res)=>{
                onRepeat(res.data)
            }).catch(({ response }) => {
                loading.value = false;
                errManager(response);
            });
        }

        return {
            t,
            loading,
            titleDialog,
            isModalVisible,
            form,
            rules,
            ruleFormRef,
            moment,
            //events
            openModal,
            onOpen,
            onClosed,
            submitForm,
            activeText

        }

    },
})
